import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {FunctionsService} from "../services/functions.service";


@Component({
  selector: 'app-be-inspired-list',
  templateUrl: './be-inspired-list.component.html'
})

export class BeInspiredListComponent implements OnInit {

  public slug = '';
  banner_image = './assets/images/banners/be-inspired-banner.jpg';

  category = {
    id: '',
    title: '',
    content: '',
    cover_image: ''
  };
  blogs = [];
  regions = [];
  categories = [];
  selected_regions = '';
  selected_categories = '';

  next = null;

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private http: HttpClient, public _auth: AuthService) {

  }

  ngOnInit() {
    // this.getRegions();
    this.route.params.subscribe(params => {
      this.next = null;
      if (params.slug) {
        this.slug = params['slug'];
        this.getCategory();
      }
      this.getBlog();
    });

    this.getCategories();
  }

  selectCategory(slug) {
    this.slug = slug;
    this.getBlog()
  }


  getRegions() {
    this.http.get(Conf.API_URL + '/areas/?show_all').subscribe(
        data => {
          this.regions = data['results'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  getCategory() {
    this.http.get(Conf.API_URL + '/category-for-blog/?show_all&slug=' + this.slug).subscribe(
        data => {
          this.category.title = data['results'][0]['title'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  getCategories() {
    this.http.get(Conf.API_URL + '/category-for-blog/?show_all&count=0').subscribe(
        data => {
          this.categories = data['results'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  choseRegion() {
    this.selected_regions = $('input[name="location"]:checked').map(function () {
      return $(this).val();
    }).get().join(',');
    this.getBlog();
  }

  getBlog() {
    var url = Conf.API_URL + '/blog/?category=' + this.slug;

    this.http.get(url).subscribe(
        data => {
          this.blogs = data['results'];
          this.next = data['next'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  loadMore() {
    this.http.get(this.next).subscribe(
        data => {
          this.blogs = this.blogs.concat(data['results']);
          this.next = data['next'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  firstParagraph(html) {
    return FunctionsService.firstParagraph(html)
  }
}




// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/be-inspired-list/be-inspired-list.component.ts